import clsx from 'clsx';
import { Icon } from 'common/icon';
import Link from 'next/link';

import styles from './styles.module.css';

interface HeaderProps {
  id?: string;
  url?: string;
  name?: string;
  count?: string | number;
  hasIcon?: boolean;
  isReviews?: boolean;
  isRtpReviews?: boolean;
  isBigName?: boolean;
  isMediumName?: boolean;
  isSmallName?: boolean;
  fromSearch?: boolean;
}

export const Header = ({
  id = '',
  url = '',
  name = '',
  count,
  isReviews,
  isRtpReviews,
  hasIcon = true,
  isBigName,
  isMediumName,
  isSmallName,
  fromSearch,
}: HeaderProps) => {
  const isLink = Boolean(url?.length);

  const className = clsx(
    hasIcon && styles.link,
    !hasIcon && styles.notlink,
    isReviews && styles.notlink,
    !isLink && styles.notlink,
    isRtpReviews && styles.rtp_notlink
  );

  const content = (
    <>
      <h2
        className={clsx(
          styles.link__name,
          fromSearch && styles.search_header,
          isBigName && styles.bigName_text,
          isMediumName && styles.mediumName_text,
          isSmallName && styles.smallName_text
        )}
      >
        {name}
      </h2>
      {Number(count) > 0 && (
        <>
          <div className={styles.link__count}>{count}</div>
          {hasIcon && <Icon.Arrow />}
        </>
      )}
    </>
  );

  if (isLink) {
    return (
      <Link id={id} prefetch={false} href={url} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <div id={id} className={className}>
      {content}
    </div>
  );
};
